/**
 * OptimalAmino — FAQ Accordion + Sidebar Nav
 * Location: Assets/optimalamino-pages.js
 */
document.addEventListener('DOMContentLoaded', function () {

 /* ── FAQ Accordion ── */
  document.querySelectorAll('.oa-faq-q').forEach(function (btn, i) {
    var item = btn.closest('.oa-faq-item');
    var panel = item.querySelector('.oa-faq-a');

    // Initialize ARIA state on load
    btn.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
    if (panel) {
      if (!panel.id) panel.id = 'oa-faq-panel-' + i;
      btn.setAttribute('aria-controls', panel.id);
    }

    btn.addEventListener('click', function () {
      var item = this.closest('.oa-faq-item');
      var wasOpen = item.classList.contains('open');

      // Close all items in the same group and reset their buttons
      item.closest('.oa-faq-group').querySelectorAll('.oa-faq-item').forEach(function (el) {
        el.classList.remove('open');
        var q = el.querySelector('.oa-faq-q');
        if (q) q.setAttribute('aria-expanded', 'false');
      });

      // Toggle clicked item
      if (!wasOpen) {
        item.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Sidebar category nav — scroll to group + highlight active ── */
  document.querySelectorAll('.oa-sidebar__list a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href').substring(1);
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Update active state
        document.querySelectorAll('.oa-sidebar__list a').forEach(function (a) {
          a.classList.remove('active');
        });
        this.classList.add('active');
      }
    });
  });

});